import React,{Component} from 'react'
import firebase from '../helper/firebase'

import {
  Button,
  MenuItem,
  TextField,
} from 'material-ui'

import CheckIcon from 'material-ui-icons/Check'

const years = [
  {
    value:1,
    label:'1 years',
  },
  {
    value:2,
    label:'2 years',
  },
  {
    value:3,
    label:'3 years',
  },
  {
    value:4,
    label:'4 years',
  },
  {
    value:5,
    label:'5 years',
  },
  {
    value:6,
    label:'6 years',
  },
  {
    value:7,
    label:'7 years',
  },
  {
    value:8,
    label:'8 years',
  },
  {
    value:9,
    label:'9 years',
  },
  {
    value:10,
    label:'10 years',
  },
  {
    value:11,
    label:'10+ years',
  },
]

const levels = [
  {
    value:1,
    label:'★☆☆☆☆ - Novice'
  },
  {
    value:2,
    label:'★★☆☆☆ - Beginner'
  },
  {
    value:3,
    label:'★★★☆☆ - Skillful'
  },
  {
    value:4,
    label:'★★★★☆ - Experienced'
  },
  {
    value:5,
    label:'★★★★★ - Expert'
  },
]

const style = {
  newListItemContainer:{
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
  },
  listItem:{
    flexGrow: '1',
    marginRight: '5px',
    marginLeft: '5px',
    minWidth: '100px'
  },
  saveSkillBtn:{
    marginBottom: '7px'
  },
}

export default class AddSkill extends Component{
  constructor(){
    super();

    this.state = {
      newSkill:'',
      years:'',
      level:'',
    }
  }

  handleFormInput=(e,formField)=>{
    this.setState({
      [`${formField}`]:e.target.value,
      newSkillError:false,
      yearsError:false,
      levelError:false,
    })
  }

  validateSkill=()=>{
    const {newSkill,years,level} = this.state;
    if (!newSkill){
      this.props.actions.setSnack(true,'Please complete all fields to add new skill')
      this.setState({newSkillError:true})
      return;
    }
    if (!years){
      this.props.actions.setSnack(true,'Please complete all fields to add new skill')
      this.setState({yearsError:true})
      return;
    }
    if (!level){
      this.props.actions.setSnack(true,'Please complete all fields to add new skill')
      this.setState({levelError:true})
      return;
    }
    else{
      this.saveSkill()
    }
  }

  saveSkill=()=>{
    const {newSkill,years,level} = this.state;
    const {uid} = this.props;
    const sid = firebase.database().ref().push().key;
    let promises = [];
    let skill = {
      name:newSkill.toLowerCase(),
      name_display:newSkill,
      years,
      level,
      uid,
      sid,
      timestamp:Date.now(),
    }
    const firestorePromise = firebase.firestore().collection('skills').doc(uid).set({
      [`${sid}`]:skill,
    },{merge:true})
    // const rtdbPromise = firebase.database().ref(`skills/${uid}/${sid}`).update(skill)
    promises.push(firestorePromise)
    // promises.push(rtdbPromise)
    Promise.all(promises)
    .then(()=>{
      this.setState({
        newSkill:'',
        years:'',
        level:'',
      })
    })
    .catch(error=>{
      console.log(error);
      this.props.setSnack(true,'Error')
    })
  }

  render(){
    return(
      <div style={style.newListItemContainer}>
        <TextField
          error={this.state.newSkillError}
          id="skills"
          label="Skill Name"
          value={this.state.newSkill}
          onChange={e=>{this.handleFormInput(e,'newSkill')}}
          onKeyPress={this.saveNewSkill}
          margin="normal"
          style={style.listItem}
        />
        <TextField
          error={this.state.yearsError}
          id="select-years"
          select
          label="Experience"
          value={this.state.years}
          onChange={e=>{this.handleFormInput(e,'years')}}
          margin="normal"
          style={style.listItem}
        >
          {years.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          error={this.state.levelError}
          id="select-level"
          select
          label="Level"
          value={this.state.level}
          onChange={e=>{this.handleFormInput(e,'level')}}
          margin="normal"
          style={style.listItem}
        >
          {levels.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <Button style={style.saveSkillBtn} dense size="small" aria-label="Save" disabled={this.state.newSkill.length===0} onClick={this.validateSkill} color="primary">
          <CheckIcon />
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AddSkill.js